export const TRAFFIC_BY_SOURCE_START_DATE = '2026-06-19';

export const TRAFFIC_SOURCES = [
  { key: 'direct', label: 'Direct' },
  { key: 'organic_search', label: 'Organic Search' },
  { key: 'paid_search', label: 'Paid Search' },
  { key: 'organic_social', label: 'Organic Social' },
  { key: 'paid_social', label: 'Paid Social' },
  { key: 'email', label: 'Email' },
  { key: 'referral', label: 'Referral' },
];
